import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import FormAutocomplete from "../../forms/FormAutocomplete";
import { Control } from "react-hook-form/dist/types/form";
import Tile from "../../../types/tile";

interface Props {
  control: Control<Tile, any>;
  formValues: Tile;
  loadWithSkeleton: (
    element: React.ReactNode
  ) =>
    | string
    | number
    | boolean
    | Iterable<React.ReactNode>
    | JSX.Element
    | null
    | undefined;
}

const GraphInfo: React.FC<Props> = (props) => {
  const { control, formValues, loadWithSkeleton } = props;

  return (
    <>
      {!!formValues.type?.hasXAxis && (
        <>
          <Box display="flex" flexDirection="row" width="100%" mt={2}>
            <Typography fontWeight="bold">Graph Settings</Typography>
          </Box>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            {loadWithSkeleton(
              <FormAutocomplete
                control={control}
                fieldName="xAxisDataType"
                label="X-Axis Data Type"
                required={!!formValues.type?.hasXAxis}
                disabled={!formValues.type?.hasXAxis}
                options={
                  !!formValues?.type?.hasXAxis
                    ? formValues?.dataType?.supportedXAxisTypes || []
                    : []
                }
                noOptionsText={
                  !!formValues.dataType && !!formValues.type
                    ? "No x-axis types available"
                    : "Select tile type to load available x-axis types"
                }
              />
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            {loadWithSkeleton(
              <FormAutocomplete
                control={control}
                fieldName="xAxisIncrement"
                label="X-Axis Increment"
                required={!!formValues.type?.hasXAxis}
                options={
                  (!!formValues.type?.hasXAxis && !!formValues.xAxisDataType
                    ? formValues?.dataType?.supportedXAxisTypes?.find(
                        (x) => x.id === formValues.xAxisDataType?.id
                      )?.supportedIncrementTypes
                    : []) || []
                }
                noOptionsText={
                  !!formValues.dataType &&
                  !!formValues.type &&
                  !!formValues.xAxisDataType
                    ? "No x-axis increments available"
                    : "Select x-axis to load available x-axis types"
                }
              />
            )}
          </Grid2>
          {!!formValues?.type?.hasYAxis && (
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              {loadWithSkeleton(
                <FormAutocomplete
                  control={control}
                  fieldName="yAxisDataType"
                  label="Y-Axis Data Type"
                  required={!!formValues.type?.hasYAxis}
                  options={
                    !!formValues?.type?.hasYAxis
                      ? formValues?.dataType?.supportedYAxisTypes || []
                      : []
                  }
                  noOptionsText={
                    !!formValues.dataType && !!formValues.type
                      ? "No y-axis types available"
                      : "Select tile type to load available y-axis types"
                  }
                />
              )}
            </Grid2>
          )}
        </>
      )}
    </>
  );
};

export default GraphInfo;
